import Contract from "slotworks/utils/contract";
import gameState from "slotworks/model/game-state";
import { parallel, sequence } from "slotworks/utils/race-utils";
import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";

export default function CelebratePotsCommand(): Contract<void> {
    if(gameState.getCurrentGame().isBuyout) {
        return  StaticSymbolsCommand();
    }
    return sequence([
            () => Contract.getTimeoutContract(1500),
            () => StaticSymbolsCommand()
    ]);
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/commands/celebrate-pots-command.ts